import type { FaireProductEntity } from "../../entity_types/product";

export const p_j3rmabjcjz: FaireProductEntity = {
  token: "p_j3rmabjcjz",
  type: "product",
  name: "Autumn Berry Pitcher Little Notes®",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/daa0c7139a12503d8f05eec932e858b95c758df45a5375ad87a8fb99807f6c59.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1c118fa131ac223acaa1467d1a684b8934610704016cbafec3dec812471b5583.jpeg",
    "https://cdn.faire.com/fastly/1434f69866ac115a52f809dd9c7791c1d617c13751fe1132048b93ecfe054b07.jpeg",
    "https://cdn.faire.com/fastly/e6582d35547a90bb9e6ddc50119394999f39f94dc7176fd4336886cb00fbf207.jpeg",
  ],
  priceDollars: 7,
  description:
    "Little Notes® are tiny in size and big on heart. Small enough to slip in a pocket, a lunch box, or a stack of books, each one carries something much larger than its size: a laugh, a love note, a reminder that someone is seen. Whether it’s a joke tucked into a backpack, a to-do list turned sweet, or a simple “thank you,” Little Notes bring joy to life’s little, big and in-between moments.\n\nEvery Little Note features hand-painted watercolor illustrations, front and back, so even the simplest message feels special. With 55 per pack, you can mix, match and share freely. Over 69 million Little Notes have already been shared worldwide, sparking connection one small gesture at a time.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:24.055Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
